import { atom } from 'jotai';
import { createMutationAtom } from 'atoms/create-resource-atom';
import {
  StructureGridListResponse,
  StructureGridProfilesResponse,
  Well3DViewerResponse,
} from 'types/api-responses';

export const paddedBoundingBoxGeometryAtom = atom<GeoJSON.Polygon | null>(null);
export const wellSearchEnvelopeAtom = atom<GeoJSON.Polygon | null>(null);

export const wellDeviationSurveyMutationAtom = createMutationAtom<
  Well3DViewerResponse,
  'wellDeviationSurvey'
>();

export const structureGridCollectionsAtom = createMutationAtom<
  StructureGridListResponse,
  'structureGridCollections'
>();

export const structureGridProfilesAtom = createMutationAtom<
  StructureGridProfilesResponse,
  'structureGridProfiles'
>();
